export const placeholderTools = [
    {
    id: 2,
    title: "Laminadora en frío 650mm",
    description: "Máquina Laminadora en Frío",
    image: "/images/herramientas/LAMFRIA.png",
    specs: ["Ancho máximo de laminación 650mm"],
    Precio_unidad: 3000,
    CantXcaja: 1,
    details: {
      zoom: "/images/herramientas/LAMFRIA.png",
    },
  },
  {
    id: 3,
    title: "Laminadora en frío 750mm",
    description: "Máquina Laminadora en Frío",
    image: "/images/herramientas/laminadora750.webp",
    specs: ["Ancho máximo de laminación 750mm"],
    Precio_unidad: 3500,
    CantXcaja: 1,
    details: {
      zoom: "/images/herramientas/laminadora750.webp",
    },
  },
  {
    id: 4,
    title: "Laminadora en frío 1000mm",
    description: "Máquina Laminadora en Frío",
    image: "/images/herramientas/laminadora1000.jpg",
    specs: ["Ancho máximo de laminación 10000mm"],
    Precio_unidad: 7000,
    CantXcaja: 1,
    details: {
      zoom: "/images/herramientas/laminadora1000.jpg",
    },
  },  {
    id: 38,
    title: "Laminadora jumbo 1600M",
    description: "Máquina Laminadora en Frío",
    image: "/images/herramientas/laminadorapie.png",
    specs: ["Ancho máximo de laminación 16000mm"],
    Precio_unidad: 15000,
    CantXcaja: 1,
    details: {
      zoom: "/images/herramientas/laminadorapie.png",
    },
  },
  {
    id: 34,
    title: "Pegadora IZZI Transfer",
    description: "Máquina Pegadora para la impresión, fotografía y photobooks",
    image: "/images/herramientas/izzitransfer.png",
    specs: ["Peso: 59kg","Dimesiones: 81x61x52 cm", "Voltaje: 220v", "Bobina Adhesiva de 32cm x 200mts","Bobina Adhesiva de 42cm x 200mts", "Bobina Adhesiva de 52cm x 200mts", "Bobina Adhesiva de 52cm x 200mts"],
    Precio_unidad: 110000,
    CantXcaja: 1,
    details: {
      zoom: "/images/herramientas/izzitransfer.png",
      zoom_detalle: "/images/herramientas/izzidetalle.jpg",
    },
  },
  {
    id: 6,
    title: "Engrapadora",
    description: "V-nailer, marco de imagen neumático, Joiner.",
    image: "/images/herramientas/VnailerVerde.webp",
    specs: ["Impulsa clavos en V de 7mm a 15mm", "Tiene capacidad para 200 piezas de clavos", "Solo 2,5 kg de peso"],
    Precio_unidad: 5000,
    CantXcaja: 1,
    details: {
      zoom: "/images/herramientas/VnailerVerde.webp",
    },
  },
  {
    id: 7,
    title: "Grapas flexipunta",
    description: "Grapa flexipunta",
    image: "/images/grapas/1.webp",
    specs: ["Caja con 4300 grapas", "Grapa para ensambladora de marcos", "Garantía del vendedor: 1 mes"],
    Precio_unidad: 550,
    CantXcaja: 10,
    details: {
      zoom: "/images/grapas/1.webp",
    },
  },
  {
    id: 8,
    title: "Grapas 7mm",
    description: "Grapa encolada de 7mm",
    image: "/images/grapas/2.webp",
    specs: ["Caja con 4300 grapas", "Grapa para ensambladora de marcos", "Garantía del vendedor: 1 mes"],
    Precio_unidad: 275,
    CantXcaja: 10,
    details: {
      zoom: "/images/grapas/2.webp",
    },
  },
  {
    id: 9,
    title: "Grapas 10mm",
    description: "Grapa encolada de 10mm",
    image: "/images/grapas/2.webp",
    specs: ["Caja con 4300 grapas", "Grapa para ensambladora de marcos", "Garantía del vendedor: 1 mes"],
    Precio_unidad: 275,
    CantXcaja: 10,
    details: {
      zoom: "/images/grapas/2.webp",
    },
  },
  {
    id: 10,
    title: "Grapas 12mm",
    description: "Grapa encolada de 12mm",
    image: "/images/grapas/2.webp",
    specs: ["Caja con 4300 grapas", "Grapa para ensambladora de marcos", "Garantía del vendedor: 1 mes"],
    Precio_unidad:275,
    CantXcaja: 10,
    details: {
      zoom: "/images/grapas/2.webp",
    },
  },
  {
    id: 11,
    title: "MDF",
    description: "Macocel para enmarcado",
    image: "/images/grapas/MDF.webp",
    specs: ["Medidas: 11'x14', 16'x20', 20'x24'.Precios desde 40 MXN ","Personalizable", "Fácil instalación", "Resistente al tiempo"],
    Precio_unidad: 40,
    CantXcaja: 1,
    details: {
      zoom: "/images/grapas/MDF.webp",
    },
  },

  {
    id: 12,
    title: "Caballete",
    description: "Caballete Mini",
    image: "/images/grapas/caballetepe.webp",
    specs: ["Hay tres verciones de mini: pequeño, mediano y grande", "Tablero de fibra de madera"],
    Precio_unidad: 90,
    CantXcaja: 1,
    details: {
      zoom: "/images/grapas/caballetepe.webp",
    },
  },
  {
    id: 35,
    title: "Caballete",
    description: "Caballete Pequeño",
    image: "/images/grapas/caballetemed.webp",
    specs: ["5.9inch 15cm de altura", "Tablero de fibra de madera"],
    Precio_unidad: 300,
    CantXcaja: 1,
    details: {
      zoom: "/images/grapas/caballetepe.webp",
    },
  },
  {
    id: 13,
    title: "Caballete",
    description: "Caballete Mediano",
    image: "/images/grapas/caballetemed.webp",
    specs: ["20inch 50.8cm de altura", "Tablero de madera"],
    Precio_unidad: 400,
    CantXcaja: 1,
    details: {
      zoom: "/images/grapas/caballetemed.webp",
    },
  },
  {
    id: 14,
    title: "Caballete",
    description: "Caballete Grande",
    image: "/images/grapas/caballetegran.webp",
    specs: ["59inch 150cm de altura", "Tablero de madera"],
    Precio_unidad: 500,
    CantXcaja: 1,
    details: {
      zoom: "/images/grapas/caballetegran.webp",
    },
  },
  {
    id: 15,
    title: "Cinta Adhesiva Doble Cara Más Adhesivo",
    description: "Cinta adhesiva doble cara",
    image: "/images/grapas/cintadoblecara.png",
    specs: ["Rollo un 25'x40m"],
    Precio_unidad: 1300,
    CantXcaja: 1,
    details: {
      zoom: "/images/grapas/cintadoblecara.png",
      zoom_detalle: "/images/detalles/adhesivodetalle.webp",
    },
  },
  {
    id: 16,
    title: "Cinta Adhesiva Doble Cara Más Adhesivo",
    description: "Cinta adhesiva doble cara",
    image: "/images/grapas/cintadoblecara.png",
    specs: ["Rollo un 50'x40m"],
    Precio_unidad: 2600,
    CantXcaja: 1,
    details: {
      zoom: "/images/grapas/cintadoblecara.png",
      zoom_detalle: "/images/detalles/adhesivodetalle.webp",
      detalle2: "/images/detalles/detalleadhesivolateral.jpg",
      detalle3: "/images/detalles/detalleadhesivodepie.jpg",
    },
  },
  
  {
    id: 37,
    title: "Cinta Adhesiva Master, Más Adhesivo",
    description: "Cinta adhesiva doble cara",
    image: "/images/grapas/adhesivomaster.jpg",
    specs: ["Rollo un 66'x50m"],
    Precio_unidad: 2320,
    CantXcaja: 1,
    details: {
      zoom: "/images/grapas/adhesivomaster.jpg",
      zoom_detalle: "/images/detalles/adhesivomasterdetalle.jpg",
      detalle2: "/images/detalles/adhesivomasterdetalle1.jpg",
    },
  },
  {
    id: 36,
    title: "Cinta Adhesiva Master, Más Adhesivo",
    description: "Cinta adhesiva doble cara",
    image: "/images/grapas/adhesivomaster.jpg",
    specs: ["Rollo un 132x50m"],
    Precio_unidad: 4640,
    CantXcaja: 1,
    details: {
      zoom: "/images/grapas/adhesivomaster.jpg",
      zoom_detalle: "/images/detalles/adhesivomasterdetalle1.jpg",
      zoom_detalle2: "/images/detalles/adhesivomasterdetalle.jpg",
    },
  },
  {
    id: 17,
    title: "Rollo de Textura Piel",
    description: "Rollo de Textura Piel Más Adhesivo",
    image: "/images/herramientas/txt-ejemplo.png",
    specs: ["Rollo un 25'x40m"],
    Precio_unidad: 1300,
    CantXcaja: 1,
    details: {
      zoom: "/images/detalles/piel.webp",
      zoom_detalle: "/images/detalles/pieldetalle.webp",
      detalle2: "/images/detalles/pieldetalle1.webp",
      detalle3: "/images/detalles/pieldetalle2.webp",
      detalle4: "/images/detalles/pieldetalle3.webp",
      detalle5: "/images/detalles/pieldetalle4.webp",
    },
  },
  {
    id: 21,
    title: "Rollo de Textura Piel",
    description: "Rollo de Textura Piel Más Adhesivo",
    image: "/images/herramientas/txt-ejemplo.png",
    specs: ["Rollo un 50'x40m"],
    Precio_unidad: 2600,
    CantXcaja: 1,
    details: {
      zoom: "/images/detalles/piel.webp",
      zoom_detalle: "/images/detalles/pieldetalle.webp",
      detalle2: "/images/detalles/pieldetalle1.webp",
      detalle3: "/images/detalles/pieldetalle2.webp",
      detalle4: "/images/detalles/pieldetalle3.webp",
      detalle5: "/images/detalles/pieldetalle4.webp",
    },
  },
  {
    id: 18,
    title: "Rollo de Textura Lino Fino",
    description: "Rollo de Textura Lino Fino Más Adhesivo",
    image: "/images/herramientas/txt-ejemplo.png",
    specs: ["Rollo un 25'x40m"],
    Precio_unidad: 1300,
    CantXcaja: 1,
    details: {
      zoom: "/images/detalles/linofino.webp",
      zoom_detalle: "/images/detalles/linofinodetalle.webp",
      detalle2: "/images/detalles/linoFinodetalle1.webp",
      detalle3: "/images/detalles/linoFinodetalle2.webp",
      detalle4: "/images/detalles/linoFinodetalle3.webp",
      detalle5: "/images/detalles/linoFinodetalle4.webp",
    },
  },
  {
    id: 22,
    title: "Rollo de Textura Lino Fino",
    description: "Rollo de Textura Lino Fino Más Adhesivo",
    image: "/images/herramientas/txt-ejemplo.png",
    specs: ["Rollo un 50'x40m"],
    Precio_unidad: 2600,
    CantXcaja: 1,
    details: {
      zoom: "/images/detalles/linofino.webp",
      zoom_detalle: "/images/detalles/linofinodetalle.webp",
      detalle2: "/images/detalles/linoFinodetalle1.webp",
      detalle3: "/images/detalles/linoFinodetalle2.webp",
      detalle4: "/images/detalles/linoFinodetalle3.webp",
      detalle5: "/images/detalles/linoFinodetalle4.webp",
    },
  },
  {
    id: 19,
    title: "Rollo de Textura Santex",
    description: "Rollo de Textura Santex Más Adhesivo",
    image: "/images/herramientas/txt-ejemplo.png",
    specs: ["Rollo un 25'x40m"],
    Precio_unidad: 1300,
    CantXcaja: 1,
    details: {
      zoom: "/images/detalles/santex.webp",
      zoom_detalle: "/images/detalles/santexdetalle.webp",
      detalle2: "/images/detalles/santexdetalle1.webp",
      detalle3: "/images/detalles/santexdetalle2.webp",
      detalle4: "/images/detalles/santexdetalle3.webp",
      detalle5: "/images/detalles/santexdetalle4.webp",
    },
  },
  {
    id: 23,
    title: "Rollo de Textura Santex",
    description: "Rollo de Textura Santex Más Adhesivo",
    image: "/images/herramientas/txt-ejemplo.png",
    specs: ["Rollo un 50'x40m"],
    Precio_unidad: 2600,
    CantXcaja: 1,
    details: {
      zoom: "/images/detalles/santex.webp",
      zoom_detalle: "/images/detalles/santexdetalle.webp",
      detalle2: "/images/detalles/santexdetalle1.webp",
      detalle3: "/images/detalles/santexdetalle2.webp",
      detalle4: "/images/detalles/santexdetalle3.webp",
      detalle5: "/images/detalles/santexdetalle4.webp",
    },
  },
  {
    id: 20,
    title: "Rollo de Textura Canvas",
    description: "Rollo de Textura Canvas Más Adhesivo",
    image: "/images/herramientas/txt-ejemplo.png",
    specs: ["Rollo un 25'x40m"],
    Precio_unidad: 1300,
    CantXcaja: 1,
    details: {
      zoom: "/images/detalles/canvas.webp",
      zoom_detalle: "/images/detalles/canvasdetalle.webp",
      detalle2: "/images/detalles/canvasdetalle1.webp",
      detalle3: "/images/detalles/canvasdetalle2.webp",
      detalle4: "/images/detalles/canvasdetalle3.webp",
      detalle5: "/images/detalles/canvasdetalle4.webp",
    },
  },  
  {
    id: 24,
    title: "Rollo de Textura Canvas",
    description: "Rollo de Textura Canvas Más Adhesivo",
    image: "/images/herramientas/txt-ejemplo.png",
    specs: ["Rollo un 50'x40m"],
    Precio_unidad: 2600,
    CantXcaja: 1,
    details: {
      zoom: "/images/detalles/canvas.webp",
      zoom_detalle: "/images/detalles/canvasdetalle.webp",
      detalle2: "/images/detalles/canvasdetalle1.webp",
      detalle3: "/images/detalles/canvasdetalle2.webp",
      detalle4: "/images/detalles/canvasdetalle3.webp",
      detalle5: "/images/detalles/canvasdetalle4.webp",
    },
  },

]

export const products = [
  // {
  //   id: 25,
  //   title: "Romana",
  //   description: "Moldura Exclusiva de Romana Centro",
  //   image: "/images/molduras/romana.webp",
  //   specs: ["Colores: Vino, Nogal, Plata, Oro, Oro 89", "Cortada a medida", "Barra entera (2.9m)", "Poliestireno"],
  //   Precio_unidad: 120,
  //   CantXcaja: 20,
  //   details: {
  //     vino: "/images/detalles/romanavino.webp",
  //     vino_detalle: "/images/detalles/romanavinodetalle.webp",
  //     nogal: "/images/detalles/romananogal.webp",
  //     nogal_detalle: "/images/detalles/romananogaldetalle.webp",
  //     plata: "/images/detalles/romanaplata.webp",
  //     plata_detalle: "/images/detalles/romanaplatadetalle.webp",
  //     oro: "/images/detalles/romanaoro.webp",
  //     oro_detalle: "/images/detalles/romanaorodetalle.webp",
  //     oro89: "/images/detalles/romanaoro89.webp",
  //     oro89_detalle: "/images/detalles/romanaoro89detalle.webp",
  //   },
  // },
  {
    id: 26,
    title: "Florencia",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/florencia.JPG",
    specs: ["Colores: Plata, Vino, Nogal, Cobre, Titanio ", "Cortada a medida", "Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 120,
    CantXcaja: 17,
    details: {
      vino: "/images/detalles/florenciavino.webp",
      vino_detalle: "/images/detalles/florenciavinodetalle.webp",
      nogal: "/images/detalles/florencianogal.webp",
      nogal_detalle: "/images/detalles/florencianogaldetalle.webp",
      cobre: "/images/detalles/florenciacobre.webp",
      cobre_detalle: "/images/detalles/florenciacobredetalle.webp",
      titanio: "/images/detalles/florenciatitanio.webp",
      titanio_detalle: "/images/detalles/florenciatitaniodetalle.webp",
      plata: "/images/detalles/florenciaplata.webp",
      plata_detalle: "/images/detalles/florenciaplatadetalle.webp",
    },
  },
  {
    id: 27,
    title: "Nápoles",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/napoles.webp",
    specs: ["Colores: Negro, Chocolate, Vino, Nogal,Titanio", "Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 120,
    CantXcaja: 24,
    details: {
      negro: "/images/detalles/napolesnegro.webp",
      negro_detalle: "/images/detalles/napolesnegrodetalle.webp",
      chocolate: "/images/detalles/napoleschocolate.webp",
      chocolate_detalle: "/images/detalles/napoleschocolatedetalle.webp",
      vino: "/images/detalles/napolesvino.webp",
      vino_detalle: "/images/detalles/napolesvinodetalle.webp",
      nogal: "/images/detalles/napolesnogal.webp",
      nogal_detalle: "/images/detalles/napolesnogaldetalle.webp",
      titanio: "/images/detalles/napolestitanio.webp",
      titanio_detalle: "/images/detalles/napolestitaniodetalle.webp",
    },
  },
  {
    id: 28,
    title: "Milán",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/milan.webp",
    specs: ["Colores: Negro, Plata, Bronce", "Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 120,
    CantXcaja: 34,
    details: {
      negro: "/images/detalles/milannegro.webp",
      negro_detalle: "/images/detalles/milannegrodetalle.webp",
      plata: "/images/detalles/milanplata.webp",
      plata_detalle: "/images/detalles/milanplatadetalle.webp",
      bronce: "/images/detalles/milanbronce.webp",
      bronce_detalle: "/images/detalles/milanbroncedetalle.webp",
    },
  },
  {
    id: 29,
    title: "Lazio",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/Lazio.jpg",
    specs: ["Colores: Negro, Plata, Chocolate, Nogal, Oro", "Cortada a medida", "Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 55,
    CantXcaja: 100,
    details: {
      nogaloscuro: "/images/detalles/Laziodetallenogaloscuro.jpg",
      nogal: "/images/detalles/Laziodetallenogall.jpg",
      negro: "/images/detalles/Laziodetallenegro.jpg",
      oro: "/images/detalles/Laziodetalleoro.jpg",
      plata: "/images/detalles/Laziodetalleplata.jpg",
    },
  },
  {
    id: 30,
    title: "452",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/452principal.jpg",
    specs: ["Colores: Negro, Nogal, LH07, Vino ", "Cortada a medida", "Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 120,
    CantXcaja: 43,
    details: {
      negro: "/images/detalles/452negro.webp",
      negro_lateral: "/images/detalles/452negrolateral.webp",
      nogal: "/images/detalles/452nogal.webp",
      nogal_lateral: "/images/detalles/452nogallateral.webp",
      lh07: "/images/detalles/452choco.webp",
      lh07_lateral: "/images/detalles/452chocolateral.webp",
      vino: "/images/detalles/452vino.webp",
      vino_lateral: "/images/detalles/452vinolateral.webp",
    },
  },
  {
    id: 31,
    title: "913",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/913principal.jpg",
    specs: ["Colores: 07-Gold, 07-Silver, BR, 12-Gold, 12-Silver ", "Cortada a medida", "Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 120,
    CantXcaja: 36,
    details: {
      gold: "/images/detalles/913-07detallegold.webp",
      gold_lateral: "/images/detalles/913-07detallegoldlateral.webp",
      silver: "/images/detalles/913-07platanogal.webp",
      silver_lateral: "/images/detalles/913-07platanogallateral.webp",
      br: "/images/detalles/913detallebrown.webp",
      br_lateral: "/images/detalles/913detallebrownlateral.webp",
      gold_12: "/images/detalles/913-12detallegold.webp",
      gold_12_lateral: "/images/detalles/913-12detallegoldlateral.webp",
      silver_12: "/images/detalles/913-12detalleplata.webp",
      silver_12_lateral: "/images/detalles/913-12detalleplatalateral.webp",
    },
  },
  {
    id: 32,
    title: "1564",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/1564-07principal.jpg",
    specs: ["Colores: Negro, Nogal, Vino", "Cortada a medida", "Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 120,
    CantXcaja: 40,
    details: {
      negro: "/images/detalles/1564-07negro.webp",
      negro_lateral: "/images/detalles/1564-07negrolateral.webp",
      nogal: "/images/detalles/1564-07nogal.webp",
      nogal_lateral: "/images/detalles/1564-07nogallateral.webp",
      vino: "/images/detalles/1564-07vino.webp",
      vino_lateral: "/images/detalles/1564-07vinolateral.webp",
    },
  },
  {
    id: 33,
    title: "1148",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/1148principal.jpg",
    specs: ["Colores: Nogal, Vino", "Cortada a medida", "Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 80,
    CantXcaja: 70,
    details: {
      nogal: "/images/detalles/1148-12nogal.webp",
      nogal_lateral: "/images/detalles/1148-12nogallateral.webp",
      vino: "/images/detalles/1148-07vino.webp",
      vino_lateral: "/images/detalles/1148-07vinolateral.webp",
    },
  },
  {
    id: 39,
    title: "1148",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/1148nc.jpg",
    specs: ["Colores: Chocolate, Negro", "Cortada a medida", "La cantidad de molduras es variable 56 en negro, 63 en chocolate","Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 80,
    CantXcaja: 70,
    details: {
      chocolate: "/images/detalles/1148chodetalle.jpg",
      negro: "/images/detalles/1148ngdetalle.jpg",
    },
  },
  {
    id: 40,
    title: "555",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/555.jpg",
    specs: ["Colores: Negro, Vino , Nogal", "Cortada a medida", "Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 120,
    CantXcaja: 26,
    details: {
      nogal: "/images/detalles/555detallenegro.jpg",
      vino: "/images/detalles/555detallevino.jpg",
      negro: "/images/detalles/555detallenogal.jpg",
    },
  },
  {
    id: 41,
    title: "Faldon",
    description: "Moldura para enmarcado de alta resistencia",
    image: "/images/molduras/Faldon.jpg",
    specs: ["Colores: Magnolia, Nogal", "Cortada a medida", "La cantidad de molduras es variable 56 en negro, 63 en chocolate","Barra entera (2.9m)", "Poliestireno"],
    Precio_unidad: 120,
    CantXcaja: 28,
    details: {
      chocolate: "/images/detalles/faldonmagnolia.jpg",
      negro: "/images/detalles/faldonnogal.jpg",
    },
  }
]


export const allProducts = [...placeholderTools, ...products]

export const detailsmolduras = [
  {
    id: 1,
    title: "Romana",
    description: "Romana Vino",
    image: "/images/detalles/SS/romanavinodetalle.webp",
  },
  {
    id: 2,
    title: "Romana",
    description: "Romana Nogal",
    image: "/images/detalles/SS/romananogaldetalle.webp",
  },
  {
    id: 3,
    title: "Romana",
    description: "Romana Plata",
    image: "/images/detalles/SS/romanaplatadetalle.webp",
  },
  {
    id: 4,
    title: "Romana",
    description: "Romana Oro",
    image: "/images/detalles/SS/romanaorodetalle.webp",
  },
  {
    id: 5,
    title: "Romana",
    description: "Romana Oro 89",
    image: "/images/detalles/SS/romanaoro89detalle.webp",
  },
  {
    id: 7,
    title: "florencia",
    description: "florencia vino",
    image: "/images/detalles/SS/florenciavinodetalle.webp",
  },
  {
    id: 8,
    title: "florencia",
    description: "florencia Nogal",
    image: "/images/detalles/SS/florencianogaldetalle.webp",
  },
  {
    id: 9,
    title: "florencia",
    description: "florencia Cobre",
    image: "/images/detalles/SS/florenciacobredetalle.webp",
  },
  {
    id: 10,
    title: "florencia",
    description: "florencia Plata",
    image: "/images/detalles/SS/florenciaplatadetalle.webp",
  },
  {
    id: 11,
    title: "florencia",
    description: "florencia Titanio",
    image: "/images/detalles/SS/florenciatitaniodetalle.webp",
  },
  {
    id: 12,
    title: "Venecia",
    description: "Venecia Oro",
    image: "/images/detalles/SS/florenciaveneciadetalle.webp",
  },
]
